import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from "./url.service";

@Injectable({
  providedIn: 'root'
})
export class GenericService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('', httpClient, toastrService, url);
  }

  postObject(url: string, object: any, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow(url, this.getBody(object), afterPostCallback, customMessage);
  }

  putObject(url: string, id: number | string, object: any, afterPutCallback?: Function, customMessage?: string) {
    return this.putNow(`${url}/${id}`, this.getBody(object), afterPutCallback, customMessage);
  }

  activateObject(url: string, id: number, afterPutCallback?: Function, customMessage?: string) {
    return this.activateNow(`${url}/activate/${id}`, afterPutCallback, customMessage);
  }

  deactivateObject(url: string, id: number, afterPutCallback?: Function, customMessage?: string) {
    return this.deactivateNow(`${url}/deactivate/${id}`, afterPutCallback, customMessage);
  }

  deleteObject(url: string, id: number, afterDeleteCallback?: Function, customMessage?: string) {
    return this.deleteNow(`${url}/${id}`, afterDeleteCallback, customMessage);
  }

  addLinkedObject(url: string, id: number, linkedObjectId: number, afterPostCallback?: Function, customMessage?: string) {
    return this.postNow(url.replace("{id}", id.toString()), linkedObjectId, afterPostCallback, customMessage);
  }

  removeLinkedObject(url: string, id: number, linkedObjectId: number, afterDeleteCallback?: Function, customMessage?: string) {
    var removeUrl: string = url.replace("{id}", id.toString()).replace("{linkedObjectId}", linkedObjectId.toString());
    return this.deleteNow(removeUrl, afterDeleteCallback, customMessage);
  }
}
